import { ChevronLeft, ChevronRight, Pause, Play } from 'lucide-react';
import type { ReactElement } from 'react';

const ICON_BUTTON_CLASS =
  'flex size-7 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

interface HeroSliderControlsProps {
  readonly selectedIndex: number;
  readonly count: number;
  readonly onPrev: () => void;
  readonly onNext: () => void;
  /** 자동 넘김이 켜질 수 있을 때만 정지·재생 버튼을 낸다(동작 줄이기면 내지 않는다). */
  readonly canAutoplay: boolean;
  readonly isPlaying: boolean;
  readonly onTogglePlay: () => void;
}

/**
 * 히어로 슬라이드 조작 — 반투명 알약 안에 이전·현재/전체·다음, 옆에 정지·재생.
 * 이전·다음은 끌기를 못 하는 키보드·단일 포인터 사용자도 넘길 수 있게 한다(WCAG 2.5.7).
 */
export const HeroSliderControls = ({
  selectedIndex,
  count,
  onPrev,
  onNext,
  canAutoplay,
  isPlaying,
  onTogglePlay,
}: HeroSliderControlsProps): ReactElement => (
  <div className="flex items-center gap-2">
    <div className="flex h-11 items-center gap-1 rounded-full bg-background/50 px-2 text-xs tabular-nums">
      <button
        type="button"
        onClick={onPrev}
        aria-label="이전 슬라이드"
        className={ICON_BUTTON_CLASS}
      >
        <ChevronLeft aria-hidden className="size-4" />
      </button>
      <span aria-hidden className="min-w-8 text-center">
        {selectedIndex + 1} / {count}
      </span>
      <button
        type="button"
        onClick={onNext}
        aria-label="다음 슬라이드"
        className={ICON_BUTTON_CLASS}
      >
        <ChevronRight aria-hidden className="size-4" />
      </button>
    </div>
    {canAutoplay ? (
      <button
        type="button"
        onClick={onTogglePlay}
        aria-label={isPlaying ? '슬라이드 자동 넘김 멈추기' : '슬라이드 자동 넘김 재생'}
        className="flex size-11 items-center justify-center rounded-full bg-background/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {isPlaying ? (
          <Pause aria-hidden className="size-4" />
        ) : (
          <Play aria-hidden className="size-4" />
        )}
      </button>
    ) : null}
  </div>
);
